import { FullScreenApplication } from '../application';
import { TYPES } from '../constants';
import { IACCommunication, IACHub, Navigator } from '..';
import { IACUsecase } from '../iacType/iacUsecase';

const doNotTrack = {
  tracking_track: 0,
  tracking_campaign: 0,
  theme_sync: 0,
  __connect__: 0,
  __connected__: 0,
  __disconnect__: 0,
  __disconnected__: 0,
  update_trinity_information: 0,
  monitoring_start_mark: 0,
  monitoring_end_mark: 0,
  monitoring_delete_mark: 0,
};

export class IACTracking {

  public static track(iacUsecase: IACUsecase): void {
    if (!(iacUsecase.getName() in doNotTrack)) {
      const focusedApp = Navigator.getFocusedApplication();
      let focusedSysname = 'none';

      if (focusedApp instanceof FullScreenApplication) {
        focusedSysname = focusedApp.getSysname();
      }

      const usecase = IACCommunication.createUsecase('tracking_track', {
        section: 'usecase',
        modifier: '-,waimg1',
        type: 'event',
        label: {
          fgapp: focusedSysname,
          usecase: iacUsecase.getName(),
          type: iacUsecase.protocol.getFlags() & TYPES.RPC ? 'RPC' : 'RPE',
          sender: iacUsecase.getSender(),
          receivers: iacUsecase.config.apps,
        },
      });
      usecase.asRPE();

      IACHub.handle(usecase);
    }
  }

}
